var React = require('react');

function Facebook (props) {
    props = { ...{"viewBox":"0 0 10 20"}, ...props };
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M9.609 10.007H6.593V20H2.126v-9.993H0v-3.53h2.126V4.193C2.126 2.556 2.962 0 6.633 0l3.31.013V3.44H7.542c-.391 0-.948.181-.948.963v2.075H10l-.391 3.53z"}));
}

module.exports = Facebook;

Facebook.default = Facebook;
